import { render, staticRenderFns } from "./research-pull-out.vue?vue&type=template&id=0ae2d704&scoped=true&"
import script from "./research-pull-out.ts?vue&type=script&lang=ts&"
export * from "./research-pull-out.ts?vue&type=script&lang=ts&"
import style0 from "./research-pull-out.scss?vue&type=style&index=0&id=0ae2d704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2d704",
  null
  
)

export default component.exports